import { showToastMessage } from './commonFunctions';

export function parseTLE(tleString: string) {
    const line_1 = tleString.substring(0, 69);
    const line_2 = tleString.substring(69);
    const lines = [line_1, line_2];

    if (lines.length !== 2) {
        showToastMessage('error', 'Invalid TLE format: Expected 2 lines');
        return null;
    }

    const parseLine1 = (line: string) => {
        return [
            { label: "Line Number", value: line.substring(0, 1), description: "Always '1'" },
            { label: "Space", value: line.substring(1, 2), description: "Space" },
            { label: "Catalog Number", value: line.substring(2, 7), description: "NORAD catalog number" },
            { label: "Classification", value: line.substring(7, 8), description: "U, C, S" },
            { label: "Space", value: line.substring(8, 9), description: "Space" },
            { label: "International Designator (Launch Year)", value: line.substring(9, 11), description: "Launch year" },
            { label: "International Designator (Launch Number)", value: line.substring(11, 14), description: "Launch number" },
            { label: "International Designator (Piece of Launch)", value: line.substring(14, 17), description: "Piece of the launch" },
            { label: "Space", value: line.substring(17, 18), description: "Space" },
            { label: "Epoch Year", value: line.substring(18, 20), description: "Epoch year" },
            { label: "Epoch Day", value: line.substring(20, 32), description: "Day of the year" },
            { label: "Space", value: line.substring(32, 33), description: "Space" },
            { label: "First Time Derivative of Mean Motion", value: line.substring(33, 43), description: "1st derivative of mean motion" },
            { label: "Space", value: line.substring(43, 44), description: "Space" },
            { label: "Second Time Derivative of Mean Motion", value: line.substring(44, 52), description: "2nd derivative of mean motion" },
            { label: "Space", value: line.substring(52, 53), description: "Space" },
            { label: "BSTAR Drag Term", value: line.substring(53, 61), description: "BSTAR drag term" },
            { label: "Space", value: line.substring(61, 62), description: "Space" },
            { label: "Ephemeris Type", value: line.substring(62, 63), description: "Ephemeris type" },
            { label: "Space", value: line.substring(63, 64), description: "Space" },
            { label: "Element Set Number", value: line.substring(64, 68), description: "Element set number" },
            { label: "Checksum", value: line.substring(68, 69), description: "Checksum" }
        ];
    };

    const parseLine2 = (line: string) => {
        return [
            { label: "Line Number", value: line.substring(0, 1), description: "Always '2'" },
            { label: "Space", value: line.substring(1, 2), description: "Space" },
            { label: "Catalog Number", value: line.substring(2, 7), description: "NORAD catalog number" },
            { label: "Space", value: line.substring(7, 8), description: "Space" },
            { label: "Inclination [degrees]", value: line.substring(8, 16), description: "Inclination" },
            { label: "Space", value: line.substring(16, 17), description: "Space" },
            { label: "Right Ascension of the Ascending Node [degrees]", value: line.substring(17, 25), description: "Right ascension" },
            { label: "Space", value: line.substring(25, 26), description: "Space" },
            { label: "Eccentricity", value: line.substring(26, 33), description: "Eccentricity" },
            { label: "Space", value: line.substring(33, 42), description: "Space" },
            { label: "Argument of Perigee [degrees]", value: line.substring(34, 42), description: "Argument of perigee" },
            { label: "Space", value: line.substring(42, 43), description: "Space" },
            { label: "Mean Anomaly [degrees]", value: line.substring(43, 51), description: "Mean anomaly" },
            { label: "Space", value: line.substring(51, 52), description: "Space" },
            { label: "Mean Motion [revolutions/day]", value: line.substring(52, 63), description: "Mean motion" },
            { label: "Revolution Number at Epoch", value: line.substring(63, 68), description: "Revolution number" },
            { label: "Checksum", value: line.substring(68, 69), description: "Checksum" }
        ];
    };

    try {
        const line1Data = parseLine1(lines[0]);
        const line2Data = parseLine2(lines[1]);
        return [line1Data, line2Data];
    } catch (error) {
        showToastMessage('error', 'Error parsing TLE lines. Check TLE format.');
        console.error("TLE Parsing Error:", error);
        return null;
    }
}

export const extract_TLE = (inputString: string): {
    line_1: string;
    line_2: string;
} | null => {
    if (!inputString) {
        return null; // Handle empty input
    }
    const lines = inputString.split(/\r?\n/).filter(line => (line.trim() !== ''));
    if (lines.length < 2) {
        return null; // Not enough lines for a TLE
    }
    const tleLines: string[] = [];
    for (const line of lines) {
        if (line.trim().length < 69) continue;
        else if (line.trim().startsWith('1') || line.trim().startsWith('2')) {
            tleLines.push(line.trim());
        }
    }
    if (tleLines.length !== 2) {
        return null; // Didn't find exactly two TLE lines
    }
    return {
        line_1: tleLines[0].slice(0, 69),
        line_2: tleLines[1].slice(0, 69),
    };
};
